import { createTool } from '@mastra/client-js'
import { z } from 'zod'
import store from 'src/store'
import { actions as appActions } from 'src/store/modules/app'

import { IUseRouterGlobalSearchSearchQuery } from 'src/hooks/router/useGlobalSearch'

export const globalSearchTool = createTool({
  id: 'global-search',
  description:
    'Perform a global search across all CRM objects. Use this when user wants to find contacts, deals, companies, or any other records by name, email, phone, or other criteria.',
  inputSchema: z.object({
    searchQuery: z.string().describe('Search query string to find CRM objects'),
  }),
  outputSchema: z.object({
    success: z.boolean(),
    message: z.string(),
  }),
  execute: async (context: any) => {
    const { searchQuery } = context

    const querySearch: IUseRouterGlobalSearchSearchQuery = {
      globalSearch: {
        query: searchQuery,
      },
    }
    store.dispatch(
      appActions.navigate({
        search: querySearch,
      })
    )

    return {
      success: true,
      message: `Searching for: ${searchQuery}`,
    }
  },
})
